import React from 'react';
import Tooltip from '../forms/Tooltip';

const Column = ({ value, transformFunction, parentItem, isSmall = false, isLarge = false, disableTooltip = false }) => {
    let transformedValue = transformFunction ? transformFunction(value, parentItem) : value;
    let otherTooltip = '';
    if (transformedValue && transformedValue.label && transformedValue.tooltip) {
        otherTooltip = transformedValue.tooltip;
        transformedValue = transformedValue.label;
    }
    return (
        <Tooltip
            title={disableTooltip || typeof transformedValue !== 'string' ? null : otherTooltip || transformedValue}
        >
            <div
                className={`ckp-tables-body-column u-truncate ${isLarge ? 'is-large' : ''} ${
                    isSmall ? 'is-small' : ''
                }`}
            >
                {transformedValue}
            </div>
        </Tooltip>
    );
};

export default Column;
